import LinkButton from 'components/shared/button/LinkButton';
import {
  areas,
  CONFIGURE_VIEW,
  CV_VIEW,
  INSIGHT_TYPE,
  NUMBER_ZERO,
  VIEW,
} from 'constants/constants';
import { useState } from 'react';
import { Col, Row, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  setConfigureInsightProducts,
  setConfigureInsightSquad,
  setCards as setInsightCards,
  setIsAccountableProductConfigure,
} from 'store/customer/customerViewSlice';
import {
  setActiveTab,
  setCards,
  setImpactedCards,
  setRefreshTiles,
  setShowSuccess,
} from 'store/home/homeMyViewSlice';
import { setAdvanceOptions } from 'store/trends_v2/trendsSlice';
import ConfigureViewModel from './ConfigureViewModel';
import classes from './ConfigureViewModel.module.scss';
import ViewDropdown from './ViewDropdown';
import { Fade } from 'react-awesome-reveal';
import { usePromiseTracker } from 'react-promise-tracker';
import { toast } from 'react-toastify';
import { saveReorderedTiles } from 'store/home/home-my-view-actions';
import { reorderMappedTiles } from 'utils/utils';
import TileReorder from './TileReorder';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';

function ConfigureViewHeader({ page }) {
  const navigation = useNavigate();
  const { promiseInProgress: insightViewPromise } = usePromiseTracker({
    area: 'getView',
  });
  const { promiseInProgress: insightViewCardPromise } = usePromiseTracker({
    area: areas.customerView,
  });

  const isMyView = page === CONFIGURE_VIEW.myView ? true : false;
  const isMyDefault = page === CONFIGURE_VIEW.myDefault ? true : false;
  const isInsights = page?.toLowerCase().indexOf('insights') > -1;
  const insightType = useSelector((state) => state?.CustomerView?.insightType);
  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );
  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const selectedUserView = useSelector(
    (state) => state?.HomeMyView?.selectedView
  );
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  const selectedView = isInsights
    ? selectedInsightView
      ? selectedInsightView
      : allInsightViews?.[0]
    : selectedUserView;

  const slice = isInsights ? 'CustomerView' : 'HomeMyView';
  const isSampleInsight =
    insightType === INSIGHT_TYPE.SAMPLE && page === CONFIGURE_VIEW.insights
      ? true
      : false;

  const { allMViews, allDViews } = useSelector((state) => state?.HomeMyView);
  const [modalShow, setModalShow] = useState(false);

  const allViews = isInsights
    ? allInsightViews
    : !isMyView
      ? allDViews
      : allMViews;

  const [showReorderModal, setShowReorderModal] = useState(false);

  const dispatch = useDispatch();
  const totalTileCount = useSelector(
    (state) => state?.HomeMyView?.totalTileCount
  );
  const cards = useSelector((state) => state[slice]?.cards);
  const defaultCards = useSelector((state) => state?.HomeMyView?.defaultCards);

  const onSaveReorderModel = async (savedCards, updatedCards) => {
    try {
      const changedCards = savedCards?.filter((originalCard) => {
        const updatedCard = updatedCards.find(
          (item) => item.cardId === originalCard.cardId
        );
        return (
          updatedCard &&
          originalCard.positionIndex !== updatedCard.positionIndex
        );
      });

      const payload = {
        viewId: updatedCards[0]?.viewId,
        cards: changedCards.map((card) => ({
          cardId: card.cardId,
          positionIndex: updatedCards.find(
            (item) => item.cardId === card.cardId
          )?.positionIndex,
        })),
      };

      const data = await saveReorderedTiles(
        payload,
        isInsights ? CONFIGURE_VIEW.insights : CONFIGURE_VIEW.myView
      );

      const finalCards = reorderMappedTiles(updatedCards, cards);

      // Refresh tiles if cards are less than total tile count
      if (cards.length < totalTileCount) {
        dispatch(setRefreshTiles(Math.random()));
      }

      setShowReorderModal(false);

      if (data) {
        toast.success(`Tiles reordered successfully.`);
        dispatch(
          isInsights ? setInsightCards(finalCards) : setCards(finalCards)
        );
      } else {
        toast.error('Failed to reorder tiles.');
      }
    } catch (error) {
      console.log(error);
      toast.error('An error occurred while reordering tiles.');
      setShowReorderModal(false);
    }
  };

  const hideModal = () => {
    setModalShow(false);
    dispatch(setShowSuccess(false));
    dispatch(setIsAccountableProductConfigure(true));
    dispatch(setConfigureInsightProducts({ options: [], selectedValue: [] }));
    dispatch(setConfigureInsightSquad({ options: [], selectedValue: [] }));
    dispatch(setAdvanceOptions(null));
  };

  const navigateToHome = () => {
    if (isMyDefault) dispatch(setActiveTab('myDefault'));
    if (isMyView) dispatch(setImpactedCards([]));
    navigation('/home');
  };

  const isConfigurable =
    !isSampleInsight && !isMyDefault && allViews?.length > 0;

  const tooltip = () => {
    return (
      <Tooltip className='gne-tooltip'>
        <span className='text text__x-small'>
          These sample tiles help you begin your journey of answering business
          questions. Click on the three dots on any tile to copy a particular
          tile to any of your My Views. Click on Copy View on the right to bring
          this sample view to your My Views to explore and modify the tiles
          further per your preference.
        </span>
      </Tooltip>
    );
  };

  const items = page === CONFIGURE_VIEW.myDefault ? defaultCards : cards;

  return (
    <div>
      <Row>
        <Col sm={7}>
          {isInsights ? (
            <div>
              <div className='d-flex justify-content-between align-items-top w-100 p-0 m-0'>
                <span>
                  {CV_VIEW.HEALTH_SYSTEM_VIEW.includes(
                    selectedCustomer.flag
                  ) && (
                    <div className='d-flex align-items-center '>
                      <span className='title title__bold title__large d-inline-block me-1'>
                        Insights{' '}
                      </span>
                      <span
                        className={`badge rounded-pill mx-2  ${classes['badgeStyle']} ${
                          isInsights ? classes['insightBadge'] : ''
                        }`}>
                        {cards?.length > NUMBER_ZERO
                          ? totalTileCount
                          : NUMBER_ZERO}{' '}
                        Tiles
                      </span>
                      {!isSampleInsight && (
                        <span className=' w-100 title title__x-small title__italic pt-0 m-0 title__grey ms-1'>
                          Insight tiles save automatically; the top right Save
                          button doesn’t apply.
                        </span>
                      )}
                    </div>
                  )}
                </span>
              </div>
            </div>
          ) : (
            <LinkButton
              className='d-flex align-items-center p-0 mb-2'
              onClick={navigateToHome}>
              <i className='icon icon__back'></i>{' '}
              <span className='text text__small'>Back to Home</span>
            </LinkButton>
          )}
        </Col>
        {isInsights && (
          <Col
            md={5}
            className='d-flex justify-content-end align-items-top px-1'>
            <Row className='g-1'>
              {isConfigurable && (
                <Col onClick={() => setModalShow(true)}>
                  <LinkButton className='d-flex text-nowrap title title__blue title__bold title__small text-capitalize'>
                    <i className='icon icon__configure'></i>Configure {page}
                  </LinkButton>
                </Col>
              )}

              {isConfigurable && (
                <Col>
                  <LinkButton
                    disabled={cards?.length === 0}
                    onClick={() => setShowReorderModal(true)}>
                    <div className='d-flex justify-content-center align-items-center p-0 m-0'>
                      <i
                        className={`icon icon__${
                          cards?.length > 0
                            ? 'table-cells-blue'
                            : 'table-cells_gray'
                        }`}></i>
                      <span
                        className={`title title${
                          cards?.length > 0 ? '__blue' : '__grey'
                        } title__bold title__small`}>
                        Reorder
                      </span>
                    </div>
                  </LinkButton>
                </Col>
              )}
            </Row>
          </Col>
        )}
      </Row>
      <Row className='mb-4 flex-nowrap'>
        {/* Left Section */}
        <Col
          md={5}
          className='d-flex justify-content-start align-items-center'>
          {allViews?.length > 0 && !isInsights && (
            <>
              <ViewDropdown
                viewOptions={allViews}
                selectedView={selectedView}
                page={page}
              />
              {isMyDefault && (
                <OverlayTrigger overlay={tooltip()}>
                  <i className={`icon icon__info__gray me-3`} />
                </OverlayTrigger>
              )}
              <span
                className={`badge rounded-pill ${classes['badgeStyle']} ${
                  isInsights ? classes['insightBadge'] : ''
                }`}>
                {items?.length > NUMBER_ZERO ? totalTileCount : NUMBER_ZERO}{' '}
                Tiles
              </span>
            </>
          )}
        </Col>

        {/* Right Section */}
        {isMyView && (
          <Col
            md={6}
            className='d-flex justify-content-end align-items-center ms-auto'>
            <Row className='g-1'>
              {isConfigurable && (
                <Col onClick={() => setModalShow(true)}>
                  <LinkButton className='d-flex text-nowrap title title__blue title__bold title__small text-capitalize'>
                    <i className='icon icon__configure'></i>Configure {page}
                  </LinkButton>
                </Col>
              )}

              {isConfigurable && (
                <Col
                  className={`d-flex text-nowrap ${!isInsights ? 'pe-0' : ''}`}>
                  <LinkButton
                    disabled={cards?.length === 0}
                    onClick={() => setShowReorderModal(true)}>
                    <i
                      className={`icon icon__${
                        cards?.length > 0
                          ? 'table-cells-blue'
                          : 'table-cells_gray'
                      }`}></i>
                    <span
                      className={`title title${
                        cards?.length > 0 ? '__blue' : '__grey'
                      } title__bold title__small`}>
                      Reorder
                    </span>
                  </LinkButton>
                </Col>
              )}
            </Row>
          </Col>
        )}
      </Row>

      {!insightViewCardPromise && !insightViewPromise && (
        <Row>
          <Col md={12}>
            <Row>
              {isInsights &&
                allInsightViews?.length === 0 &&
                !isSampleInsight && (
                  <Fade>
                    <div className=' w-100 h-100 d-flex justify-content-center align-items-center my-5'>
                      <h3 className='title title__small'>
                        Click <span className='title__bold'>Add New View </span>{' '}
                        in the top right corner to set up your view.
                        <p className='text-center '>
                          Creating a view is{' '}
                          <span className='title__bold'>required</span> for
                          saving an insight board.
                        </p>
                      </h3>
                    </div>
                  </Fade>
                )}
            </Row>
          </Col>
        </Row>
      )}

      {!insightViewCardPromise && !insightViewPromise && (
        <Row>
          <Col md={12}>
            <Row>
              {isInsights &&
                allInsightViews?.length > 0 &&
                totalTileCount === 0 && (
                  <Fade>
                    <div className={classes.defaultMessage}>
                      <h3 className='text text__text-medium text__bold'>
                        No KPI's Selected
                      </h3>
                      <p className='text text__small mt-2'>
                        Please{' '}
                        <span
                          onClick={() => setModalShow(true)}
                          className='link'>
                          click here
                        </span>{' '}
                        to configure your insights
                      </p>
                    </div>
                  </Fade>
                )}
            </Row>
          </Col>
        </Row>
      )}
      {modalShow && (
        <ConfigureViewModel
          show={modalShow}
          page={page}
          view={VIEW.add}
          onHide={() => hideModal()}
          css={`animate__animated animate__${modalShow ? 'zoomIn' : 'zoomOut'}`}
        />
      )}

      {showReorderModal && cards?.length > 0 && (
        <TileReorder
          page={page}
          selectedView={selectedView}
          show={showReorderModal}
          onHide={() => setShowReorderModal(false)}
          onSave={onSaveReorderModel}
          cards={cards}
        />
      )}
    </div>
  );
}

export default ConfigureViewHeader;
